<template>
  <div class="EchartPractice">
    <div
      :class="className"
      :id="id"
      :style="{ width: '100%', height: '250px' }"
    ></div>
  </div>
</template>

<script>
  import * as echarts from 'echarts';
  export default {
    name: 'echart-bar',
    props: {
      className: {
        type: String,
        default: 'chart'
      },
      id: {
        type: String,
        default: 'chart'
      },
      titletop: {
        type: String
      },
      itemsData: {
        type: Array
      }
    },

    data() {
      return {
        chart: null,
        barData: []
      };
    },
    watch: {
      itemsData: {
        handler(newName, oldName) {
          if (oldName) {
            this.DrawBarChart();
          }
        },
        immediate: true,
        deep: true
      }
    },
    mounted() {
      this.DrawBarChart();
    },
    methods: {
      DrawBarChart() {
        this.barData = this.itemsData;

        let yearData = [];
        let ratingData = [];
        let markPointData = [];

        for (let i = 0; i < this.barData.length; i++) {
          yearData.push(this.barData[i].name);
          ratingData.push(this.barData[i].value);
          markPointData.push({
            name: this.barData[i].name,
            coord: [i, this.barData[i].value],
            value: this.barData[i].value
          });
        }

        if (yearData.length < 1) {
          return;
        }

        this.chart = echarts.init(document.getElementById(this.id));

        // 调用showLoading方法
        this.chart.showLoading({
          text: 'loading',
          color: '#0084cd',
          textColor: '#0084cd',
          maskColor: 'rgba(255, 255, 255, 0.2)',
          zlevel: 0
        });
        let option;

        option = {
          title: {
            subtext: this.titletop
          },
          grid: {
            x: 70
          },
          tooltip: {
            formatter: '{b}<br/> {c}',
            axisPointer: {
              type: 'shadow', //'shadow' 阴影指示器
              label: {
                backgroundColor: '#6a7985'
              }
            }
          },
          // label: {
          //   show: true,
          //   position: 'inside',
          // },

          xAxis: {
            type: 'category',
            data: yearData,
            axisLabel: {
              interval: 0
              // rotate: 40,
              // rotate: 90,
              // width: 30,
              // overflow: 'break'
            }
          },
          yAxis: {
            type: 'value',
            axisLabel: {
              interval: 0
            }
          },
          series: [
            {
              data: ratingData,
              type: 'bar',
              markPoint: {
                data: [
                  // {
                  //   type: 'max',
                  //   name: '最大值'
                  // },
                  // {
                  //   type: 'min',
                  //   name: '最小值'
                  // },
                  ...markPointData
                ]
              },
              itemStyle: {
                normal: {
                  //这里是重点
                  color: function(params) {
                    //注意，如果颜色太少的话，后面颜色不会自动循环，最好多定义几个颜色
                    var colorList = [
                      '#c23531',
                      '#188afe',
                      '#61a0a8',
                      '#d48265',
                      '#91c7ae',
                      '#749f83',
                      '#ca8622'
                    ];
                    return colorList[params.dataIndex];
                  }
                }
              }
            }
          ]
        };
        setTimeout(() => {
          this.chart.hideLoading();
          this.chart.setOption(option, true);
        }, 1000);
        //  this.chart.setOption(option)
      }
    }
  };
</script>

<style lang="less" scoped>
  .EchartPractice {
    width: 95%;
    margin: 0 auto;
  }
</style>
